"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { extractProminentColors, useMountEffect, useOnChange } from "@opensea/ui-kit/hooks";
import { createContext, useContext, useState } from "react";
import { CurrencyChartColorFragment } from "./CurrencyChartColorProvider.fragment";
import { selectBestChartColor } from "./select-best-chart-color";
const CurrencyChartColorContext = createContext(null);
export function CurrencyChartColorProvider(t0) {
  const $ = _c(11);
  const {
    currency: currencyKey,
    children
  } = t0;
  let t1;
  if ($[0] !== currencyKey) {
    t1 = readFragment(CurrencyChartColorFragment, currencyKey);
    $[0] = currencyKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currency = t1;
  const [color, setColor] = useState();
  let t2;
  if ($[2] !== currency.imageUrl) {
    t2 = async function extractColor() {
      const prominentColors = await extractProminentColors(currency.imageUrl);
      if (!prominentColors) {
        setColor(undefined);
        return;
      }
      const bestColor = selectBestChartColor(prominentColors);
      setColor(bestColor);
    };
    $[2] = currency.imageUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const extractColor = t2;
  let t3;
  if ($[4] !== extractColor) {
    t3 = () => {
      extractColor();
    };
    $[4] = extractColor;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useMountEffect(t3);
  let t4;
  if ($[6] !== extractColor) {
    t4 = () => {
      extractColor();
    };
    $[6] = extractColor;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useOnChange(currency.imageUrl, t4);
  let t5;
  if ($[8] !== children || $[9] !== color) {
    t5 = <CurrencyChartColorContext.Provider value={color}>{children}</CurrencyChartColorContext.Provider>;
    $[8] = children;
    $[9] = color;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export function useCurrencyChartColor() {
  return useContext(CurrencyChartColorContext);
}